/**
 * CTA tracking → Marketo hidden fields.
 *
 * GTM appends four query params to the destination URL on tagged CTA click.
 * On form pages we read them, persist to sessionStorage for multi-hop
 * sessions, and write into Marketo hidden fields on the form-ready hook.
 *
 * Marketo field API names match URL param names 1:1.
 */

const CTA_FIELDS = ['cta_source_page', 'cta_position', 'cta_label', 'cta_destination'];
const SESSION_KEY = 'dr_cta_attribution';
const EMPTY_CTA = Object.freeze({
    cta_source_page: '',
    cta_position: '',
    cta_label: '',
    cta_destination: '',
});

const readCtaFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    const result = {};
    let hasAny = false;
    CTA_FIELDS.forEach((name) => {
        const val = params.get(name);
        if (val) {
            result[name] = val;
            hasAny = true;
        }
    });
    return hasAny ? result : null;
};

const readCtaFromSession = () => {
    try {
        const raw = sessionStorage.getItem(SESSION_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch (e) {
        return null;
    }
};

const persistCtaToSession = (data) => {
    try {
        sessionStorage.setItem(SESSION_KEY, JSON.stringify(data));
    } catch (e) {}
};

// Merge URL params over existing session per-field so a partial URL update
// (e.g. only 2 of 4 params) doesn't wipe earlier attribution.
const resolveCta = () => {
    const fromSession = readCtaFromSession() || {};
    const fromUrl = readCtaFromUrl();
    if (fromUrl) {
        const merged = { ...fromSession, ...fromUrl };
        persistCtaToSession(merged);
        return merged;
    }
    return Object.keys(fromSession).length ? fromSession : null;
};

const attachToMarketoForms = () => {
    if (typeof MktoForms2 === 'undefined') {
        // MktoForms2 may load asynchronously; retry until it appears.
        // Mirrors the pollForForms() pattern in marketoScripts.js.
        setTimeout(attachToMarketoForms, 200);
        return;
    }
    MktoForms2.whenReady((form) => {
        const cta = resolveCta();
        if (cta) {
            form.addHiddenFields(cta);
        } else {
            // Clear "null"-string defaults set in the Marketo form admin so a
            // no-attribution submit reports empty values, not the literal "null".
            form.vals(EMPTY_CTA);
        }
        // Clear session attribution after a successful submit so subsequent
        // forms in the same session don't carry stale CTA context.
        form.onSuccess(() => {
            try {
                sessionStorage.removeItem(SESSION_KEY);
            } catch (e) {}
            // No return: let Marketo's default flow and any existing onSuccess
            // handlers (e.g. signup redirect in marketoScripts.js) proceed.
        });
    });
};

// Persist URL CTA params on every page load (not just form pages) so a later
// form visit in the same session can read them back from sessionStorage.
resolveCta();
attachToMarketoForms();
